(function(app, ng) {

    app.config([
        "$stateProvider", function($stateProvider) {
            $stateProvider.state("Home.Search",
                {
                    url: "/Search?searchTerm",
                    params: {
                       searchTerm: null
                    },
                    component: "search",
                    resolve: {
                        clientTypes: [
                            "clientApi", function(clientApi) {
                                return clientApi.getClientTypes();
                            }
                        ]
                    },
                    data: {
                        pageTitle: "Search Results"
                    }
                });
        }
    ]);

    app.component("search",
        {
            templateUrl: "/App/Search/template.html",
            controller: searchController,
            bindings: {
                clientTypes: "<"
            }
        });

    searchController.$inject = ["$state", "personApi", "$stateParams", "searchApi", "_"];

    function searchController($state, personApi, $stateParams, searchApi, _) {
        var $ctrl = this;
        $ctrl.$state = $state;

        ng.extend($ctrl,
            {
                clearFilter: clearFilter,
                goToResult: goToResult
            });

        function goToResult(result) {
            if (result.Type === "person"){
                switch (result.Value.Type) {
                case "Client":
                    $state.go("Home.Client.Activity", { clientId: result.Value.Id }, {});
                    break;
                case "Advisor":
                    $state.go("Home.Settings.Agency.Users");
                    break;
                default:
                    return;
                }
            } else if (result.Type === "Case") {
                $state.go("Home.Client.Case", { clientId: result.Value.ClientId, caseId: result.Value.Id });
            }
        }

        $ctrl.$onInit = () => {
            if ($stateParams.searchTerm) {
                searchPeople($stateParams.searchTerm).then(function(results) {
                    $ctrl.searchResults = results;
                });
            }
        }

        function searchPeople(term) {
            return searchApi.search(term).then(function (results) {
                ng.forEach(results,
                    function (row) {
                        if (row.Value.Type === "Advisor" || row.Value.Type === "Client")
                            row.Term = row.Value.FirstName + " " + row.Value.LastName;
                        if (row.Type === "Case") {
                            row.Term = row.Value.Name;
                            row.Value.Type = "Case";
                            if (row.Value.AccountNames || row.Value.AccountNumbers) {
                                row.Value.Accounts = [];
                                ng.forEach(row.Value.AccountNames, function(accountName) {
                                   
                                    var accountNumber = _.find(row.Value.AccountNumbers, function(n) {
                                        return accountName.Key === n.Key;
                                    });
                                    row.Value.Accounts.push((accountName.Value || "No Account Name") + " - " + (accountNumber ? (accountNumber.Value !== "" ? accountNumber.Value : "No Account Number") : "No Account Number"));
                                });

                                ng.forEach(row.Value.AccountNumbers, function (accountNumber) {
                                    if (_.findIndex(row.Value.AccountNames, function(a) { return a.Key === accountNumber.Key }) === -1) {

                                        var accountName = _.find(row.Value.AccountNames, function(n) {
                                            return accountNumber.Key === n.Key;
                                        });
                                        row.Value.Accounts.push((accountName ? (accountName.Value !== "" ? accountName.Value : "No Account Name") : "No Account Name") + " - " + (accountNumber.Value || "No Account Number"));
                                    }
                                });
                            }
                        }
                    });

                results.sort(function (a, b) {
                    return a.Value.Type - b.Value.Type;
                });
                $ctrl.allCount = results.length;
                $ctrl.clientCount = _.filter(results, _.iteratee(["Value.Type", "Client"])).length;
                $ctrl.advisorCount = _.filter(results, _.iteratee(["Value.Type", "Advisor"])).length;
                return results;
            });
        }

        function clearFilter() {
            $state.go("Home.Search", { searchTerm: "" });
        }
    }
})(window.app, window.angular); // jshint ignore:line